import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import PropTypes from 'prop-types';

import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';

const useStyles = makeStyles(theme => ({
  toothContainer: props => ({
    width: 'auto',
    height: '60px',
    [theme.breakpoints.down('md')]: {
      height: '50px',
      fontSize: '0.8rem'
    },
    [theme.breakpoints.down('sm')]: {
      height: '40px',
      fontSize: '0.6rem'
    },
    position: 'relative',
    textAlign: 'center',
    '& > span': {
      position: 'absolute'
    },
    color: props.fontColor || '#000'
  }),
  tooth: props => ({
    height: '100%',
    '& path': {
      fill: props.color || '#fff',
      stroke: props.border || '#000000'
    }
  }),
  toothBlue: {
    '& > g > path': {
      fill: blue[800]
    }
  },
  toothGreen: {
    '& > g > path': {
      fill: green[800]
    }
  },
  toothContainerBlue: {
    color: '#fff !important'
  },
  toothContainerGreen: {
    color: '#fff !important'
  }
}));

const Tooth = ({
  image,
  onChange,
  value,
  disabled,
  label,
  size,
  fontSize,
  fontColor,
  color,
  border,
  className,
  customRender
}) => {
  const Image = image;
  const classes = useStyles({ color, border, fontColor });

  const [mode, setMode] = useState(value);

  const modeToothClass = useMemo(() => {
    switch (mode) {
      case 1:
        return classes.toothBlue;
      case 2:
        return classes.toothGreen;
      default:
        return '';
    }
  }, [mode, classes]);

  const modeToothContainerClass = useMemo(() => {
    switch (mode) {
      case 1:
        return classes.toothContainerBlue;
      case 2:
        return classes.toothContainerGreen;
      default:
        return '';
    }
  }, [mode, classes]);

  const handleOnClick = e => {
    e.preventDefault();
    setMode(prev => {
      let m = +prev + 1;

      if (m > 2) {
        m = 0;
      }

      onChange(m);

      return m;
    });
  };

  const component = (
    <ButtonBase
      disabled={disabled}
      className={`${classes.toothContainer} ${modeToothContainerClass} ${className}`}
      onClick={handleOnClick}
      style={{ height: size, fontSize }}
    >
      <Image className={`${classes.tooth} ${modeToothClass}`} />
      {label && <span>{label}</span>}
    </ButtonBase>
  );

  if (customRender) {
    return customRender(component);
  }
  return component;
};

Tooth.propTypes = {
  value: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  image: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.number,
  fontSize: PropTypes.number,
  color: PropTypes.string,
  fontColor: PropTypes.string,
  border: PropTypes.string,
  className: PropTypes.string,
  customRender: PropTypes.func
};

Tooth.defaultProps = {
  value: 0,
  onChange: () => {},
  disabled: false,
  label: '',
  size: 60,
  fontSize: 14,
  color: null,
  fontColor: null,
  border: null,
  className: '',
  customRender: null
};

export default Tooth;
